import React, { Component } from "react";
import _ from "lodash";
import {
    Paper,
    Typography,
    Grid,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
} from "@material-ui/core";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import styled from "styled-components";
import Day from "./Day";
import DaysofWeek from "./daysofweek";
import moment from "moment";
import RightIcon from "@material-ui/icons/ArrowRight";
import LeftIcon from "@material-ui/icons/ArrowLeft";
import { Modal, ModalBody, Spinner } from "reactstrap";

import { getTimesheets, getUsers, setUser, setWeek, setYear } from "./actions";
import {
    selectData,
    selectWeek,
    selectYear,
    selectUsers,
    selectedUser,
    getRequesting,
} from "./selectors";

import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

const BorderPaper = styled(Paper)`
    border: 0px solid black;
    margin-bottom: 25px;
    margin-right: 25px;
    padding: 20px;
    width: fit-content;
    display: inline-block;
    box-shadow: none;
`;

class TimesheetManager extends Component {
    constructor(props) {
        super(props);
        let date = moment();

        props.setWeek(date.week());
        props.setYear(date.year());
        props.getUsers();
        props.getTimesheets();
    }
    render() {
        const { data, week, year, allUsers, user } = this.props;
        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5">Timesheet Manager</Typography>
                </StyledHeader>
                <StyledContent>
                    <StyledViewContainer>
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                {this.props.requesting && (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            paddingTop: "3em",
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "white",
                                                width: "fit-content",
                                                display: "inline-block",
                                                padding: "2em",
                                            }}
                                        >
                                            <Spinner
                                                style={{
                                                    height: 100,
                                                    width: 100,
                                                    background: "white",
                                                }}
                                                color="primary"
                                            />
                                            <Typography
                                                style={{
                                                    textAlign: "center",
                                                    marginTop: 15,
                                                    color:
                                                        "rgba(0, 0, 0, 0.87)",
                                                    fontWeight: "bolder",
                                                    fontSize: 20,
                                                }}
                                                variant="body2"
                                            >
                                                Processing...
                                            </Typography>
                                        </div>
                                    </div>
                                )}
                            </ModalBody>
                        </Modal>
                        <BorderPaper style={{ boxShadow: "none" }}>
                            <Typography align="center" variant="h5">
                                Year
                            </Typography>
                            <Typography align="center" variant="h5">
                                <IconButton
                                    onClick={() => {
                                        let newYear = year - 1;

                                        if (year !== 1)
                                            this.props.setYear(newYear);
                                    }}
                                >
                                    <LeftIcon />
                                </IconButton>{" "}
                                {year ? year : "0"}{" "}
                                <IconButton
                                    onClick={() => {
                                        let newYear = year + 1;
                                        this.props.setYear(newYear);
                                    }}
                                >
                                    <RightIcon />
                                </IconButton>
                            </Typography>
                        </BorderPaper>

                        <BorderPaper style={{ boxShadow: "none" }}>
                            <Typography align="center" variant="h5">
                                Week
                            </Typography>
                            <Typography align="center" variant="h5">
                                <IconButton
                                    onClick={() => {
                                        let newWeek = week - 1;

                                        if (week !== 1)
                                            this.props.setWeek(newWeek);
                                    }}
                                >
                                    <LeftIcon />
                                </IconButton>
                                {week ? week : "0"}
                                <IconButton
                                    onClick={() => {
                                        let newWeek = week + 1;
                                        if (week !== 52)
                                            this.props.setWeek(newWeek);
                                    }}
                                >
                                    <RightIcon />
                                </IconButton>
                            </Typography>
                        </BorderPaper>

                        <BorderPaper
                            style={{ boxShadow: "none", float: "right" }}
                        >
                            <FormControl style={{ minWidth: 300 }}>
                                <InputLabel>Filter By Users</InputLabel>
                                <Select
                                    value={user === false ? "all_users" : user}
                                    onChange={(event) =>
                                        this.props.setUser(event.target.value)
                                    }
                                >
                                    <MenuItem value="all_users">
                                        All Users
                                    </MenuItem>
                                    {allUsers &&
                                        Object.keys(allUsers).map((e) => {
                                            let fname =
                                                _.get(
                                                    allUsers[e],
                                                    "profile.first_name"
                                                ) || "N/A";
                                            let lname =
                                                _.get(
                                                    allUsers[e],
                                                    "profile.last_name"
                                                ) || "N/A";
                                            if (
                                                !_.get(
                                                    allUsers[e],
                                                    "profile.deleted"
                                                )
                                            )
                                                return (
                                                    <MenuItem value={e} key={e}>
                                                        {fname + " " + lname}
                                                    </MenuItem>
                                                );
                                            else return null;
                                        })}
                                </Select>
                            </FormControl>
                        </BorderPaper>
                        <Divider style={{ marginBottom: 24 }} />
                        <Grid
                            container
                            spacing={40}
                            style={{ maxHeight: 3000 }}
                        >
                            {DaysofWeek &&
                                DaysofWeek.map((e, i) => {
                                    return (
                                        <Grid item xs={12} xl={12} key={i}>
                                            <Day
                                                key={i}
                                                title={e.title}
                                                day={e.key}
                                                timesheets={data}
                                            />
                                            <Divider />
                                        </Grid>
                                    );
                                })}
                        </Grid>
                    </StyledViewContainer>
                </StyledContent>
            </StyledCard>
        );
    }
}
export default hot(module)(
    connect(
        (store) => {
            return {
                data: selectData(store),
                week: selectWeek(store),
                year: selectYear(store),
                allUsers: selectUsers(store),
                user: selectedUser(store),
                requesting: getRequesting(store),
            };
        },
        {
            getTimesheets,
            getUsers,
            setUser,
            setWeek,
            setYear,
        }
    )(TimesheetManager)
);
